const API_BASE = import.meta.env.VITE_API_URL || "";

/**
 * Wrap a publisher image URL through our same-origin proxy.
 * Pass `w` to get a sharp-resized WebP back (great for card thumbnails).
 * Pass `lqip: true` to get a 40px wide blur placeholder.
 */
export function proxied(url: string, options?: { w?: number; lqip?: boolean }): string {
  const w = options?.lqip ? 40 : options?.w;
  const params = new URLSearchParams({ url });
  if (w) params.set("w", String(w));
  return `${API_BASE}/v1/img-proxy?${params}`;
}

/**
 * Loose URL validity check used to decide whether to render an <img> at all.
 */
export function isLikelyImageUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}
